export enum Gender {
  MALE = "male",
  FEMALE = "female",
  OTHER = "other",
}

export enum FormStatus {
  Draft = "draft",
  Published = "published",
  Archived = "archived",
}

export enum WorkflowStatus {
  Draft = "draft",
  Active = "active",
  Inactive = "inactive",
  Archived = "archived",
}

export enum UserStatus {
  Pending = "pending",
  Active = "active",
  Inactive = "inactive",
}

export enum UserType {
  Admin = "Admin",
  RemoteUser = "RemoteUser",
}

export enum Status {
  Active = "active",
  Inactive = "inactive",
}

export enum AssigmentStatus {
  Assign = "assigned",
  UnAssign = "unassigned",
}
export interface UserData {
  id?: number;
  username: string;
  email: string;
  phone_num: string;
  first_name: string;
  last_name: string;
  gender: Gender;
  country: number;
  title?: string;
  description?: string;
}
